import React from "react";

export const PLANTING_PMS_HELP_TITLE = "O que é PMS?";

export function PlantingPmsHelpContent() {
  return (
    <>
      <p>
        <strong>PMS</strong> é o <strong>peso de mil sementes</strong>, em
        gramas. É um dado do lote da semente (está no rótulo ou no laudo).
      </p>
      <p>
        Neste campo ele é <strong>opcional</strong>. Use quando quiser deixar o
        peso registrado na ordem — por exemplo, para conferir saca ou converter
        quantidade.
      </p>
      <p>
        Se o abastecimento for por <strong>bag</strong> ou <strong>saca</strong>{" "}
        com quantidade já conhecida em sementes, o campo principal é{" "}
        <strong>sementes por embalagem</strong>. O PMS pode ficar em branco.
      </p>
    </>
  );
}
